export const GET_RECEIPTS = "GET_RECEIPTS";
export const GET_RECEIPTS_SUCCESS = "GET_RECEIPTS_SUCCESS";
export const GET_RECEIPTS_FAIL = "GET_RECEIPTS_FAIL";